module.exports = __webpack_public_path__ + "Flama-Extrabold.woff2?dbe11705fbcd99eece37402402cf289f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Extrabold.woff2
// module id = 917
// module chunks = 0